// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"506":"20d776ff","600":"992eea2f","855":"908836ba"}[chunkId] + ".css";
};